import React, { Component } from "react";
import { Route, Switch } from "react-router";
import Loadable from "react-loadable";

const AdminRouter = Loadable({
  loader: () =>
    import(/* webpackChunkName: "AdminRouter" */ "admin/AdminRouter"),
  loading() {
    return <div />;
  },
});

const UserRouter = Loadable({
  loader: () => import(/* webpackChunkName: "UserRouter" */ "user/UserRouter"),
  loading() {
    return <div />;
  },
});

const MurfyRouter = Loadable({
  loader: () =>
    import(/* webpackChunkName: "MurfyRouter" */ "murfy/MurfyRouter"),
  loading() {
    return <div />;
  },
});

export default class Router extends Component {
  render() {
    return (
      <Switch>
        {/* Leave admin route first to prevent matching with user routes */}
        <Route path="/admin/" component={AdminRouter} />
        <Route path="/" component={MurfyRouter} id="murfy-router" />
        <Route path="/" component={UserRouter} id="user-router" />
      </Switch>
    );
  }
}
